var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGrowPriceDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.8235C14.4016 28.5553 12.3004 29 10 29C8.7208 29 7.504 28.8624 6.4 28.6153C4.5016 28.1882 4 27.0941 4 25.3365V12.6635C4 11.5047 5.248 10.7094 6.4 10.9682C7.504 11.2153 8.7208 11.3529 10 11.3529C12.3004 11.3529 14.4016 10.9082 16 10.1765C17.5984 9.44471 19.6996 9 22 9C23.2792 9 24.496 9.13765 25.6 9.38471C27.4984 9.81176 28 10.9059 28 12.6635V25.3365C28 26.4953 26.752 27.2906 25.6 27.0318C24.496 26.7847 23.2792 26.6471 22 26.6471C19.6996 26.6471 17.5984 27.0918 16 27.8235Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6001 9V6.04836H20L16.6159 2.26927C16.5409 2.18503 16.4468 2.11722 16.3403 2.07067C16.2338 2.02413 16.1176 2 16 2C15.8824 2 15.7662 2.02413 15.6597 2.07067C15.5532 2.11722 15.4591 2.18503 15.3841 2.26927L12 6.04836H14.3999V10.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20.2V20.2108M24 17.7904V17.8024M19.0769 19C19.0769 19.7956 18.7527 20.5587 18.1757 21.1213C17.5987 21.6839 16.8161 22 16 22C15.1839 22 14.4013 21.6839 13.8243 21.1213C13.2473 20.5587 12.9231 19.7956 12.9231 19C12.9231 18.2044 13.2473 17.4413 13.8243 16.8787C14.4013 16.3161 15.1839 16 16 16C16.8161 16 17.5987 16.3161 18.1757 16.8787C18.7527 17.4413 19.0769 18.2044 19.0769 19Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGrowPriceDark);
export default __webpack_public_path__ + "static/media/ic-grow-price-dark.efaabbb87bc67bac4f085219131eb872.svg";
export { ForwardRef as ReactComponent };